import errorLogger, { BUGSNAG_STATUSES } from '@picsart/growth-rc/services/errorLogger';
import { getContext } from 'configs/context';

import { apiBaseUrl } from 'configs/constants';

export const fetchUserTier = async () => {
  try {
    const response = await getContext().utils.api.fetch(`${apiBaseUrl}/guard/users/tier`);

    return await response.json();
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.ERROR);
  }
};

export const fetchSubscriptionTiers = async () => {
  try {
    const response = await getContext().utils.api.fetch(`${apiBaseUrl}/shop/subscription/tiers`);

    return await response.json();
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.ERROR);
  }
};

export const fetchUser = async () => {
  try {
    const response = await getContext().utils.api.fetch(`${apiBaseUrl}/users/show/me.json?email_encoded=1`);

    return await response.json();
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.ERROR);
  }
};
